<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="pagination-container">
          <el-pagination
            :disabled="isLoading"
            :current-page="listQuery.page"
            :page-sizes="listQuery.sizes"
            :page-size="listQuery.size"
            :total="listQuery.total"
            background
            layout="total, sizes, pager, jumper"
            size="mini"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          />
        </div>
        <div class="button-container">
          <el-button
            :loading="isGeneratingCSV"
            type="warning"
            icon="el-icon-download"
            size="mini"
            @click="handleExportCSV"
          >
            Export CSV
          </el-button>
          <el-button
            icon="el-icon-close"
            size="mini"
            @click="resetFiliter"
          >
            Reset Filter
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleSearch"
          >
            Search
          </el-button>
        </div>
      </div>
      <div class="filter-container">
        <div class="filter-item">
          <span class="filter-title">Member Uniquename:</span>
          <el-input
            v-model="filter.uniquename"
            placeholder="Please Input"
            clearable
          />
        </div>
        <div class="filter-item">
          <span class="filter-title">Member Email:</span>
          <el-input
            v-model="filter.email"
            placeholder="Please Input"
            clearable
          />
        </div>
        <div class="filter-item">
          <span class="filter-title">Date:</span>
          <gx-date-range-select
            :date-range.sync="filter.dateRange"
            :disabled="isLoading"
            @selectedDateRange="handleSelectedDateRange"
          />
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      stripe
      border
      style="width: 100%"
    >
      <el-table-column
        sortable
        prop="created_at"
        label="Activity Date"
        width="120"
      />
      <el-table-column
        sortable
        prop="txn_type"
        label="Type"
      />
      <el-table-column
        sortable
        prop="uniquename"
        label="Member Uniquename"
      />
      <el-table-column
        sortable
        prop="email"
        label="Member Email"
      />
      <el-table-column
        sortable
        prop="status"
        label="Status"
      />
      <el-table-column
        sortable
        prop="point_entitled"
        label="Point Entitled"
      />
      <el-table-column
        sortable
        prop="point_earned"
        label="Point Earned"
      />
      <el-table-column
        sortable
        prop="point_redeemed"
        label="Point Redeemed"
      />
    </el-table>

  </sticky-header-layout>
</template>

<script>
import format from 'date-fns/format'
import { getPointStatus, generatePointStatusCSV } from '../../api/memberships'
import fileDownload from '../../utils/file-download'

import useTablePaging from '../../mixins/useTablePaging'
import { getUTCDate } from '../../utils/helper'

export default {
  name: 'Orders',
  mixins: [useTablePaging],
  data() {
    return {
      filter: this.getDefaultFilter(),
      customDateRange: [],
      isLoading: false,
      isGeneratingCSV: false,
    }
  },
  computed: {
    canExportCSV() {
      return this.list.length > 0
    },
  },
  methods: {
    getDefaultFilter() {
      return {
        uniquename: '',
        email: '',
        dateRange: { value: 'thisMonth', label: 'This Month' },
      }
    },
    getPayload() {
      return {
        startDate: this.customDateRange.length > 0 ? format(getUTCDate(this.customDateRange[0]), 'yyyy-MM-dd') : null,
        endDate: this.customDateRange.length > 0 ? format(getUTCDate(this.customDateRange[1]), 'yyyy-MM-dd') : null,
        uniquename: this.filter.uniquename.length > 0 ? this.filter.uniquename : null,
        email: this.filter.email.length > 0 ? this.filter.email : null,
      }
    },
    async getList() {
      this.isLoading = true
      const payload = this.getPayload()
      try {
        const response = await getPointStatus(payload, this.listQuery.page, this.listQuery.size)
        const { pagination, data: newList } = response
        this.list = []
        if (Array.isArray(newList)) {
          this.list = newList
        }
        this.listQuery.total = parseInt(pagination.total_items, 0)
      } catch (error) {
        this.list = []
      } finally {
        this.isLoading = false
      }
    },
    async handleExportCSV() {
      this.isGeneratingCSV = true
      const payload = this.getPayload()

      try {
        const response = await generatePointStatusCSV(payload)
        const isCSV = response.headers['content-type'] === 'application/excel'
        const { data } = response
        this.isGeneratingCSV = false

        if (!isCSV) {
          this.$alert(data.data.message, 'Success', {
            confirmButtonText: 'OK',
            type: 'warning',
          })
          return
        }

        fileDownload(data, 'goxip_point_status.csv')
      } catch (error) {
        console.log(error)
        this.isGeneratingCSV = false
      }
    },
    handleSelectedDateRange(dateRange) {
      this.customDateRange = dateRange
    },
    handleSearch() {
      this.getList()
    },
    resetFiliter() {
      this.filter = this.getDefaultFilter()
      this.customDateRange = []
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.filter-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-grow: 1;
  .filter-title {
    font-size: 13px;
    margin-right: 5px;
  }
}

section {
  .filter-item {
    margin: 3px 0;
    width: 100%;
    @include mobile {
      margin: 3px 5px;
      width: calc(100% / 3 - 10px);
    }
    @include tablet {
      width: calc(100% / 4 - 10px);
    }
    @include desktop {
      width: calc(100% / 6 - 10px);
    }
  }
  .data-picker-container {
    position: relative;
    // Make the hack button span the whole parent container.
    .absolute-view {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}

</style>

